/**
 * Remix Icon calendar-event-fill (Apache-2.0) — filled calendar with day marker,
 * aligned with Figma handoff for campaign date fields.
 */
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon'

export function CampaignCalendarPickerIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path d="M17 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V1H9V3H15V1H17V3ZM4 9V19H20V9H4ZM6 13H11V17H6V13Z" />
    </SvgIcon>
  )
}
